import { render } from "./ArticlePagePaginated.vue?vue&type=template&id=7b5fdd26"
import script from "./ArticlePagePaginated.vue?vue&type=script&lang=js"
export * from "./ArticlePagePaginated.vue?vue&type=script&lang=js"

import "./ArticlePagePaginated.vue?vue&type=style&index=0&id=7b5fdd26&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__